import React, { Component } from "react";
import withRouter from "../../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NoRecords } from "../../../Components/Shimmer";
import { formatDate } from "../../../Components/InputElements";

class EducationalDetailsView extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_degree: "",
      institute_university: "",
      year_of_passout: "",
      percentage_grade: "",
      employee_qualification_document: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      errors: {},
      data: [],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ data: this.props.data }, (prevState) => {
      console.log("Educationl Deatils this.state.data ====================>>>>>>",this.state.data)
      //   this.GetList();
    });
  }
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: { ...prevState.errors, [name]: "" },
    }));
  };

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;
    const employee_id = this.props.params.employee_id;
    var formData = new FormData();

    // Appending data to the FormData object
    formData.append("employee_id", employee_id);
    formData.append("employee_degree", this.state.employee_degree);
    formData.append("institute_university", this.state.institute_university);
    formData.append("year_of_passout", this.state.year_of_passout);
    formData.append("percentage_grade", this.state.percentage_grade);

    // Append the file
    formData.append(
      "employee_qualification_document",
      this.state.employee_qualification_document
    );

    axios
      .post(`${apiURL}Employees/CreateEmployeeQualification`, formData, {
        headers,
      })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          this.setState({
            employee_degree: "",
            institute_university: "",
            year_of_passout: "",
            percentage_grade: "",
            employee_qualification_document: "",
          });
          this.closeRef.current.click();

          this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
          });
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? "Success" : "Failed"
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            timer: 2000,
            showConfirmButton: true,
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? "Success" : "Failed"
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            timer: 2000,
            showConfirmButton: true,
            allowOutsideClick: false,
          });
          this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
          });
        }
      });
  };
  handleSelectFile = (e) => {
    const file = e.target.files[0];
    this.setState({
      employee_qualification_document: file,
      selectedFileName: file ? file.name : "",
    });
  };
  removeSelectedFile = () => {
    this.setState({
      employee_qualification_document: null,
      selectedFileName: "",
    });
  };

  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeQualifications`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, {
            headers,
          })
          .then((response) => {
            Swal.fire({
              title: `<strong>${
                response.data.success === true ? "Success" : "Failed"
              }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  // Custom validation function with regex
  validateForm = () => {
    const errors = {};
    const numberRegex = /^[0-9]+$/;

    if (!this.state.institute_university)
      errors.institute_university = "Institute or University is required";
    if (!this.state.employee_degree)
      errors.employee_degree = "Degree is required";
    if (!this.state.year_of_passout)
      errors.year_of_passout = "Year of Passing is required";
    if (!this.state.percentage_grade)
      errors.percentage_grade = "Grade is required";

    if (
      this.state.percentage_grade &&
      !numberRegex.test(this.state.percentage_grade)
    )
      errors.percentage_grade = "Grade must be a number";

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <>
        <div className="d-flex justify-content-between align-itmes-center">
          <h5> Educational Details </h5>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Enter Qualification</th>
                <th>Institute</th>
                <th>Year Of Passing</th>
                <th>Grade</th>
                {/* <th>Qualification Document</th> */}

                {/* <th className="text-center">Action</th> */}
              </tr>
            </thead>
            {this.state.data?.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan={12}>
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {this.state.data.map((row) => {
                  return (
                    <tr key={row.employee_qualification_id}>
                      <td>{row.employee_degree}</td>
                      <td>{row.institute_university}</td>
                      <td>{row.year_of_passout ? formatDate(row.year_of_passout) : '--'}</td>
                      <td>{row.academic_score_value}{row?.academic_score_type === '1'
                      ? '%'
                      : row?.academic_score_type === '2'
                      ? 'Grade'
                      : row?.academic_score_type === '3'
                      ? 'CGPA'
                      : ''}</td>
                      {/* <td>
                        <div className="d-flex justify-content-center align-items-center">
                          <a
                            href={`${row.employee_qualification_document_url}`}
                            className={`${
                              !row.employee_qualification_document_url
                                ? "d-none"
                                : ""
                            } link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Uploaded Document
                          </a>
                        </div>
                      </td> */}
                      {/* <td className="d-flex justify-content-around">
                        <button
                          onClick={() =>
                            this.handleDelete(row.employee_qualification_id)
                          }
                          className="btn-icon btn btn-sm btn-outline-danger"
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </td> */}
                    </tr>
                  );
                })}
              </tbody>
            )}
            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={
                        this.state.prev === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(EducationalDetailsView);
